module.exports = __webpack_public_path__ + "static/img/police.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/police.png
// module id = HD4M
// module chunks = 57